import styled from 'styled-components'

import { Font14, H3 } from 'components/Typography'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

export const TransferLicenseModalTitle = styled(H3)`
  margin-bottom: 16px;
`

export const TransferLicenseModalParagraph = styled.p`
  ${Font14}
  text-align: center;
  margin: ${theme.spacing.xxl} 0;
`

export const TransferLicenseTableWrapper = styled.div`
  @media ${theme.devices.tablet} {
    width: max-content;
    min-width: 100%;
  }
`

export const SelectedDealerBtn = styled.div<{ $isSelected?: boolean }>`
  background: transparent;
  position: relative;
  z-index: 1;
  display: block;
  flex: none;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: 1px solid ${theme.colors.horizonOrange};
  border-radius: 50%;

  ${(p) =>
    p.$isSelected &&
    `
    &::after {
      content: '';
      position: absolute;
      z-index: 2;
      display: block;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: ${theme.colors.horizonOrange};
    }
  `}
`

export const TransferLicenseMobileContainer = styled(WhiteBlock)<{
  $isSelected?: boolean
}>`
  width: 100%;
  gap: ${theme.spacing.base};
  ${Font14}

  ${(p) =>
    p.$isSelected &&
    `
    background-color: ${theme.colors.accent10};
  `}
`

export const TransferLicenseNameRow = styled.div`
  display: flex;
  justify-content: space-between;
`
